import FormDataLatest from "issara-sdk/apis/FormDataLatest_apps_PTM";
import FormDataDetail from "issara-sdk/apis/FormDataDetail_apps_PTM";
import type FormDataRecord from "issara-sdk/types/FormDataSerializerForUpdate_apps_PTM";
import { apiErrorTextOf } from "../errorTextV4";

type Context = { apiToken?: any; extra?: { division?: number; device?: number } };
const notFound = (tuple: any): boolean => {
  const status = tuple?.[2]?.response?.status ?? tuple?.[2]?.status
    ?? tuple?.[1]?.error?.response?.status ?? tuple?.[0]?.error?.response?.status;
  return status === 404;
};
/** Match Assessment V3: prefer 0.1, then 0.2. Missing forms are ordinary empty data. */
export const loadOpeningAssessment = async (encounter: number, context: Context): Promise<FormDataRecord | null> => {
  const versions = await Promise.all(["0.1", "0.2"].map(async (form_version) => {
    let tuple;
    try {
      tuple = await FormDataLatest.retrieve({
        ...context, params: { encounter, form_code: "CardPatientAssessment", form_version },
      });
    } catch (error) {
      if ((error as any)?.response?.status === 404) return { form: null, error: null };
      return { form: null, error: error instanceof Error ? error.message : String(error) };
    }
    if (notFound(tuple)) return { form: null, error: null };
    return { form: tuple?.[0]?.id ? { ...tuple[0], form_version: tuple[0].form_version ?? form_version } as FormDataRecord : null, error: apiErrorTextOf(tuple) };
  }));
  for (const version of versions) {
    if (version.error) throw new Error(version.error);
    if (version.form) return version.form;
  }
  return null;
};
/** Re-read before merging: never discard special_requests or other assessment data. */
export const syncOpeningAssessment = async (
  encounter: number, fields: { arrive_status?: string; chief_complaint: string; triage_level: string }, context: Context,
): Promise<void> => {
  const form = await loadOpeningAssessment(encounter, context);
  if (!form) return;
  if (!fields.arrive_status) throw new Error("ไม่พบ code มาโดยใน master PAB");
  const action = form.status === "CONFIRMED" ? "CONFIRM"
    : form.status === "DRAFT" || form.status === "EDITED" ? "SAVE" : undefined;
  if (!action || (form.allowed_actions && !form.allowed_actions.includes(action))) {
    throw new Error("สถานะแบบประเมินไม่อนุญาตให้อัปเดต");
  }
  /* ต้องส่ง encounter ไปด้วยเสมอ: ฝั่ง backend (PTM FormDataSerializerForUpdate.update
     -> _update_encounter) อ่าน validated_data['encounter'] ตรง ๆ ถ้าไม่มี key นี้จะได้
     KeyError -> HTTP 500 (วัดจริงบน localhost: PUT ไม่ encounter = 500 ใช้เวลา ~62 วินาที,
     PUT ที่มี encounter = 200 ใช้ ~3 วินาที) */
  const tuple = await FormDataDetail.update({
    ...context, pk: form.id,
    data: { action, encounter,
      ...(form.form ? { form: form.form } : {
        form_code: "CardPatientAssessment", form_name: "แบบประเมินแรกรับ", form_version: form.form_version,
      }),
      data: { ...form.data, ...fields } },
  });
  const error = apiErrorTextOf(tuple);
  if (error) throw new Error(error);
};
